import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import { Wordmark } from '../Layout/Wordmark';

// Pantalla de login del prototipo iter5 (login.html): split navy con lockup +
// formulario claro. Conserva la lógica signInWithPassword del andamio; el
// redirect a /atencion lo hace LoginRoute al aparecer la sesión. Sin registro
// ni recuperación de contraseña (altas manuales, G2); el "Recordarme" del
// prototipo se omite (persistSession ya es el comportamiento por defecto).

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'error'>('idle');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus('loading');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setStatus('error');
      return;
    }
    setStatus('idle');
  }

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-[minmax(380px,44%)_1fr]">
      <section className="hidden lg:flex flex-col justify-between bg-[var(--navy)] p-12 text-white">
        <div>
          <span className="inline-flex w-fit flex-col">
            <Wordmark className="block h-6 w-auto text-[var(--orange)]" />
            <span className="mt-2.5 pt-2 border-t border-white/25 text-[10px] font-semibold uppercase tracking-[0.218em] text-white/80 whitespace-nowrap leading-none">
              Centro de Atención IA
            </span>
          </span>
          <p className="mt-14 max-w-sm text-[17px] leading-relaxed text-white/85">
            Plataforma de gestión del centro de atención telefónica de Aramática. Acceso exclusivo
            para el equipo autorizado.
          </p>
        </div>
        <div className="flex items-center gap-2.5 text-[12.5px] text-white/70">
          <span className="h-2 w-2 rounded-full bg-[var(--status-ok)] shadow-[0_0_0_3px_var(--status-ok-halo-strong)]" />
          Bot operativo
          <span className="opacity-40">·</span> Odoo 17 conectado
          <span className="opacity-40">·</span> Zaragoza
        </div>
      </section>

      <section className="flex items-center justify-center bg-[var(--bg)] p-6">
        <div className="w-full max-w-[400px] rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] p-9 shadow-[var(--shadow)]">
          <div className="mb-8 lg:hidden">
            <span className="inline-flex w-fit flex-col">
              <Wordmark className="block h-5 w-auto text-[var(--orange)]" />
              <span className="mt-2 pt-2 border-t border-[var(--border)] text-[9px] font-semibold uppercase tracking-[0.218em] text-[var(--text-2)] whitespace-nowrap leading-none">
                Centro de Atención IA
              </span>
            </span>
          </div>

          <div className="text-[11px] font-semibold uppercase tracking-wider text-[var(--orange-ink)]">
            Panel interno
          </div>
          <h1 className="mt-1 text-[22px] font-semibold text-[var(--navy)]">Inicia sesión</h1>
          <p className="mt-1 mb-7 text-[13px] text-[var(--text-dim)]">
            Accede al centro de atención de Aramática.
          </p>

          <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="mb-1.5 block text-[12.5px] font-medium text-[var(--text-2)]"
              >
                Correo
              </label>
              <input
                id="email"
                type="email"
                required
                autoComplete="username"
                placeholder="nombre@aramatica.es"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-[var(--radius-sm)] border border-[var(--border)] bg-[var(--surface)] px-3.5 py-2.5 text-sm text-[var(--text)] placeholder:text-[var(--text-mute)] focus-visible:outline-none focus-visible:border-[var(--orange)] focus-visible:shadow-[var(--ring)]"
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="mb-1.5 block text-[12.5px] font-medium text-[var(--text-2)]"
              >
                Contraseña
              </label>
              <input
                id="password"
                type="password"
                required
                autoComplete="current-password"
                placeholder="Tu contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-[var(--radius-sm)] border border-[var(--border)] bg-[var(--surface)] px-3.5 py-2.5 text-sm text-[var(--text)] placeholder:text-[var(--text-mute)] focus-visible:outline-none focus-visible:border-[var(--orange)] focus-visible:shadow-[var(--ring)]"
              />
            </div>

            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full rounded-[var(--radius-sm)] bg-[var(--orange)] py-2.5 text-sm font-semibold text-white hover:brightness-95 disabled:opacity-50 cursor-pointer"
            >
              {status === 'loading' ? 'Entrando…' : 'Entrar'}
            </button>

            {status === 'error' && (
              <p role="alert" className="text-[12.5px] font-medium text-[var(--orange-ink)]">
                Correo o contraseña incorrectos. Revísalos e inténtalo de nuevo.
              </p>
            )}
          </form>

          <div className="mt-7 border-t border-[var(--border-soft)] pt-4 text-[12px] text-[var(--text-dim)]">
            ¿Problemas para acceder? Escribe a{' '}
            <a
              className="text-[var(--orange-ink)] underline"
              href="mailto:administracion@aramatica.es"
            >
              administracion@aramatica.es
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
